import { render, staticRenderFns } from "./MyPlanJoined.vue?vue&type=template&id=3603d2a4&scoped=true"
import script from "./MyPlanJoined.vue?vue&type=script&lang=js"
export * from "./MyPlanJoined.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3603d2a4",
  null
  
)

export default component.exports